import React from 'react';
import classNames from 'classnames';
import styles from './Navigation.module.scss';
import { Link } from 'ui/components';
import { Button, Heading } from 'ui/components/1-atoms';
import { Container } from 'ui/components/4-habitats';
import NavigationMobile from './NavigationMobile/NavigationMobile';
import { SubNavigation } from './SubNavigation/SubNavigation';
import { NavigationDropDown } from './NavigationDropdown/NavigationDropdown';

export interface NavigationProps {
	className?: string;
	style?: 'primary';
	heading?: string;
	navigationItems?: Navigation.NestedNavigationItem[];
	handleMobileNavLinkClick?: () => void;
	children?: React.ReactNode;
}

export const Navigation: React.FC<NavigationProps> = ({ navigationItems = [], className, heading, style, handleMobileNavLinkClick }) => {
	return (
		<>
			<nav className={classNames(styles.Navigation, styles[`Navigation___${style}`], className, styles.Navigation_desktop)}>
				{heading && (
					<Heading headingLevel="h6" className={styles.Navigation_heading}>
						{heading}
					</Heading>
				)}
				<ul className={styles.Navigation_list}>
					{navigationItems.map((rootItem: Navigation.NestedNavigationItem, index) => {
						const title = rootItem.title ?? rootItem.name;
						const hasChildren = (rootItem.decendants?.length ?? 0) > 0;

						if (!hasChildren) {
							return (
								<li key={index} className={styles.Navigation_item}>
									<Link className={styles.Navigation_link} url={rootItem.url} target={rootItem.target}>
										{title}
									</Link>
								</li>
							);
						}

						return (
							<NavigationDropDown
								key={index}
								trigger={
									<Button
										type="button"
										className={classNames(styles.Navigation_link, styles.Navigation_buttonLike)}
										aria-haspopup="dialog"
										aria-expanded={false}
									>
										{title}
									</Button>
								}
								content={
									<div id={`nav-dd-${index}`} className={styles.Navigation_dropDownContainer} role="dialog" aria-modal="false">
										<Container width="Standard" className={styles.Navigation_dropDownContainerWrapper}>
											<div className={styles.Navigation_dropDownContainerInner}>
												{rootItem.url ? (
													<div className={styles.Navigation_parentRow}>
														<Link url={rootItem.url} target={rootItem.target} className={styles.Navigation_parentLink}>
															{title}
														</Link>
													</div>
												) : null}

												<SubNavigation root={rootItem} />
											</div>
										</Container>
									</div>
								}
							/>
						);
					})}
				</ul>
			</nav>

			<nav className={styles.Navigation_mobile}>
				<NavigationMobile navigationItems={navigationItems} handleMobileNavLinkClick={handleMobileNavLinkClick} />
			</nav>
		</>
	);
};

export default Navigation;
